<template>
  <div>
    <el-input :value="value[lang]" @input="handleChangeInput" @blur="handleInputBlur"  v-if="lang" v-bind="$attrs" />
    <nation-list
        ref="nationList"
        class="lang-box"
        @click="handleChangeCurrentLang"
        @onList="debouncedFunction"
        :high-light="lineHeightList"
        v-bind="$attrs"
        :disabled="disabledNation" />
  </div>
</template>

<script>
import NationList from "./NationList";
import {debounce} from "../../utlis/utlis";
export default {
  name: "NationInput",
  components: {NationList},
  model: {
    event: "input",
    prop: "value"
  },
  props: {
    value: {
      type: Object,
      default: () => {return {}}
    },
    disabledNation: {
      type: Boolean,
      default: false,
    },
    waitTime: {
      type: Number,
      default: 1000,
    }
  },
  data() {
    return {
      lang: "",
      langs: {},
      lineHeightList: [],
      langList: [],
      debouncedFunction: null
    }
  },
  created() {
    this.debouncedFunction = debounce(this.handleChangeInputModel, this.waitTime, false);
  },
  methods: {
    // 设置数据响应
    handleChangeInputModel(list) {
      this.langList = Array.isArray(list) ? list : [];
      list.forEach(lang => {
        let langVal = this.value[lang] || "";
        this.$set(this.value, lang, langVal);
      })
      this.$emit("input", this.value);
    },


    // 切换语言并设置高亮
    handleChangeCurrentLang(e) {
      this.lang = e.value;
      this.handleChangeHighLight();
    },

    // 设置高亮
    handleChangeHighLight() {
      let list = Object.keys(this.value);
      this.lineHeightList = list.filter(i => this.value[i] !== '' && this.value[i]);
    },

    handleInputBlur(e) {
      this.handleChangeHighLight();
      this.$emit("blur", e);
    },

    // 输入值并暴露
    handleChangeInput(val) {
      this.value[this.lang] = val;
      this.$emit('input', this.value);
    },

    handleSetDefault() {
      this.$refs.nationList.handleSetCurrent(0);
    }

  },
  watch: {
    value: {
      handler() {
        let keyLength = Object.keys(this.value).length;
        let langListLength = this.langList.length;

        // 初始化数据
        if(!keyLength && langListLength) {
          this.handleChangeInputModel(this.langList);
          this.lineHeightList = [];
          this.lang = this.langList[0];
          this.$refs.nationList.handleSetCurrent(0);
        } else if(langListLength) {
          // this.handleChangeInputModel(this.langList);
        }
      },
      immediate: true,
      deep:true,
    },
  }
}
</script>

<style scoped>
.lang-box {
  display: flex;
  margin-top: 14px;
}
</style>
